import {
  IonButton,
  IonButtons,
  IonIcon,
  IonImg,
  IonMenuButton,
  IonRouterLink,
  IonText,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { menuOutline } from "ionicons/icons";
import { useContext } from "react";

import { ApiTokenContext } from "@/contexts/api-token/ApiContextWrapper";
import { UserContext } from "@/contexts/user/UserContext";
import { createNavigationProps } from "@/utils/common";
import {
  DASHBOARD_MENU_ITEM,
  GET_STARTED_MENU_ITEM,
  LOGIN_MENU_ITEM,
  LOGOUT_MENU_ITEM,
  MAIN_MENU_ITEMS,
} from "@/utils/constants/menu";
import "./NavBarComponent.css";

function AutoNavBar() {
  const { token, logout } = useContext(ApiTokenContext),
    isLoggedIn = Boolean(token),
    { user } = useContext(UserContext);

  return (
    <IonToolbar
      className="toolbar mfp-main-toolbar"
      data-testid="navbarToolbar"
    >
      <IonButtons slot="start">
        <IonMenuButton className="ion-hide-md-up">
          <IonIcon color="secondary" icon={menuOutline} />
        </IonMenuButton>
      </IonButtons>
      <IonTitle className="ion-hide-md-up width-full">
        <img
          src="/mFP_icon.png"
          alt="myFirePlane"
          className="mfp-toolbar-center-logo"
        />
        myFirePlane
      </IonTitle>

      <IonRouterLink href="/">
        <IonImg
          src="/mFP_icon.png"
          className="logo ion-hide-md-down"
          alt="myFirePlane Logo"
        />
      </IonRouterLink>

      <IonButtons slot="end" class="menu-buttons ion-hide-md-down">
        {MAIN_MENU_ITEMS.map((menuItem, idx) => (
          <IonButton key={idx} {...createNavigationProps(menuItem.linkTo)}>
            {menuItem.label}
          </IonButton>
        ))}
      </IonButtons>

      <IonButtons slot="end" class="menu-buttons  ion-hide-md-down">
        <IonButton
          routerLink={(isLoggedIn ? LOGOUT_MENU_ITEM : LOGIN_MENU_ITEM).linkTo}
          // eslint-disable-next-line no-undefined
          onClick={isLoggedIn ? () => logout() : undefined}
        >
          <div className="logout-button-content">
            <IonText>
              {(isLoggedIn ? LOGOUT_MENU_ITEM : LOGIN_MENU_ITEM).label}
            </IonText>
            {isLoggedIn && user && (
              <IonText color="primary" className="logout-username">
                {user.ActualName || user.UserName}
              </IonText>
            )}
          </div>
        </IonButton>
        <IonButton
          fill="solid"
          shape="round"
          color="primary"
          routerLink={
            (isLoggedIn ? DASHBOARD_MENU_ITEM : GET_STARTED_MENU_ITEM).linkTo
          }
        >
          {(isLoggedIn ? DASHBOARD_MENU_ITEM : GET_STARTED_MENU_ITEM).label}
        </IonButton>
      </IonButtons>
    </IonToolbar>
  );
}

export { AutoNavBar };
